<template>
  <div class="sub-nav-v2">
    <router-link
      v-for="item in items"
      :key="item.path"
      :to="item.path"
      :class="{ active: $route.path === item.path }"
    >
      {{ item.nameKey ? $t(item.nameKey) : item.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SubNavV2',
  props: {
    items: Array
  }
}
</script>

<style lang="scss" scoped>
.sub-nav-v2 {
  display: flex;
  gap: 12px;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;

  a {
    padding: 10px 28px;
    font-size: 15px;
    font-weight: 500;
    color: #64748b;
    border-radius: 10px;
    transition: all 0.3s;

    &:hover {
      color: #3b82f6;
      background: rgba(59,130,246,0.08);
    }

    &.active {
      color: #fff;
      background: linear-gradient(135deg, #3b82f6, #06b6d4);
    }
  }
}

@media (max-width: 768px) {
  .sub-nav-v2 {
    flex-wrap: wrap;
  }
}
</style>
